// extracted by mini-css-extract-plugin
export default {"link":"RecentlyAdded_link__KAtlQ","headline":"RecentlyAdded_headline__VaVcJ","grid":"RecentlyAdded_grid__YLQDU"};